import React, { useState } from 'react';
import * as Yup from 'yup';
import {
    GridView,
    CrudMasterDetailView,
    Icon,
    Widget,
    CompositeView,
    MasterDetailForm,
    FormInput,
    FormSelect,
    FormTextArea,
    FormSubmitButton,
    FormatText,
    CrudContext,
    ButtonDelete,
    useRouter,, Form, FormSwitch
} from '@digital/ui';
import { getAllMunicipios, createMunicipio, updateMunicipio, deleteMunicipio, ListaEstados } from '@app/api/municipio';
import { getAllUsuariosMRNAndTerceiroOptions } from '@app/api/usuario';
import { hasPermission } from '@app/helpers/permissions';

const Municipio = () => {
    const [GetAllItems, setGetAllItems] = useState(() => {
        return getAllMunicipios;
    });

    const { history } = useRouter();

    const onCreateMunicipio = (values: any) => {
        return createMunicipio(values).then(resp => {
            if (resp.valid) {
                setGetAllItems(() => Promise.resolve(undefined));
                setGetAllItems(() => getAllMunicipios);
            }
            return resp;
        });
    };

    const onUpdateMunicipio = (values: any) => {
        return updateMunicipio(values).then(resp => {
            if (resp.valid) {
                setGetAllItems(() => Promise.resolve(undefined));
                setGetAllItems(() => getAllMunicipios);
            }
            return resp;
        });
    };

    return (
        <CrudMasterDetailView
            getAllItems={GetAllItems}
            createItem={hasPermission(['DIRETORIA_CADASTRAR']) ? onCreateMunicipio : undefined}
            updateItem={onUpdateMunicipio}
            icon="maps-geo_fence"
            filterPredicate={(item, value) =>
                item.nome.toLowerCase().includes(value.toLowerCase()) ||
                (item.siglaEstado ? item.siglaEstado.toLowerCase().startsWith(value.toLowerCase()) : false)
            }
            disableNotification
            titleExtractor={d => d.nome}
            detailTitleExtractor={x => x.siglaEstado + ' - ' + x.nome}
            descriptionExtractor={d => d.siglaEstado || ''}>
            <CompositeView>
                <CrudContext.Consumer>
                    {({ selectedItem }) => {
                        return (
                            <GridView noform>
                                <MasterDetailForm
                                    validationSchema={Yup.object().shape({
                                        nome: Yup.string()
                                            .required('Nome requerido')
                                            .max(150, 'O nome deve ter no máximo 150 caracteres.'),
                                        siglaEstado: Yup.string()
                                            .required('Estado requerido'),
                                    })}>
                                    <Widget
                                        title="Dados do Município"
                                        actions={[
                                            selectedItem && hasPermission(['DIRETORIA_DELETAR']) && (
                                                <ButtonDelete
                                                icon={null}
                                                    type="danger"
                                                    confirm="Deseja realmente excluir este registro?"
                                                    okText="Confirmar"
                                                    onClick={() => {
                                                        deleteMunicipio(selectedItem.id).then(resp => {
                                                            if (resp.valid) {
                                                                setGetAllItems(() => Promise.resolve(undefined));
                                                                setGetAllItems(() => getAllMunicipios);
                                                                history.push('/municipios');
                                                            }
                                                        });
                                                    }}
                                                />
                                            ),
                                            hasPermission(['DIRETORIA_CADASTRAR']) && (
                                                <FormSubmitButton noIcon={true} type="primary">
                                                    <FormatText id="ui.commons.save" uppercase />
                                                </FormSubmitButton>
                                            ),
                                        ]}
                                    >
                                        <FormInput label="Nome" name="nome" span={4} />
                                        <FormSelect label="Estado" name="siglaEstado" span={1}
                                            options={ListaEstados}
                                        />
                                        <FormSwitch label="Comum MRN" name="comumMRN" span={1} />
                                    </Widget>
                                </MasterDetailForm>
                            </GridView>
                        );
                    }}
                </CrudContext.Consumer>
            </CompositeView>
        </CrudMasterDetailView>
    );
};
export default Municipio;